import icon1 from '../../../Assets/Icons/enterpriseGdpr.svg';
import icon2 from '../../../Assets/Icons/enterpriseActivity.svg';
import icon3 from '../../../Assets/Icons/enterpriseSaml.svg';
import icon4 from '../../../Assets/Icons/enterpriseIp.svg';
import icon5 from '../../../Assets/Icons/enterpriseSla.svg';
import icon6 from '../../../Assets/Icons/enterpriseEu.svg';

import customer1 from '../../../Assets/Icons/customer1.svg';
import customer2 from '../../../Assets/Icons/customer2.svg';
import customer3 from '../../../Assets/Icons/customer3.svg';

export const customers = [
    {
        icon:customer1,
        title:"Your design partner now, and in the future",
        desc:"We help you understand the business value of design and drive transformation from the inside out. Our close customer relationships help us shape the future of the product and tailor solutions for your needs.",
        color:"#F1EBFF",
    },
    {
        icon:customer2,
        title:"Around the clock support from day one",
        desc:"Our friendly Customer Support and Experience team is on hand from day one to help brilliant companies like yours get up and running with the answers, training and resources you need.",
        color:"#ec63231a"
    },
    {
        icon:customer3,
        title:"Scalable pricing that makes sense, no surprises",
        desc:"Our product drops jaws, not our pricing. It doesn't matter if you're starting to grow your team or transforming your business, our pricing structure is fair and based on how your teams operate.",
        color:"#ff4f5b31"
    }
]
export const security = [
    {
        icon:icon2,
        title:"Activity log exports",
        color:"#F1EBFF",
        desc:"Keep an offline record of Hostdesign activity so you can refer back to it any time you need to"
    },
    {
        icon:icon1,
        title:"GDPR compliant",
        desc:"We're committed to meeting our legal obligation and protecting the data rights of our customers",
        color:"#ec63231a"
    },
    {
        icon:icon3,
        title:"SAML-based SSO",
        desc:"Hostdesign Enterprise gives your business several layers of security to their accounts",
        color:"#ff4f5b31"
    },
    {
        icon:icon4,
        title:"IP Restriction & granular access",
        desc:"Restrict access by ensuring only users on a specific IP address can access your Hostdesign account",
        color:"#ffbf002f"
    },
    {
        icon:icon5,
        title:"99.98% Uptime SLA",
        desc:"Our distributed infrastructure means you get the best and most reliable experience possible",
        color:"#02eb021a"
    },
    {
        icon:icon6,
        title:"EU Hosted Infrastructure",
        desc:"Our data center maintains multiple certifications including SOC1, SOC 2, SOC 3, ISO27001",
        color:"#17a8ec23"
    }
]
